// extracted by mini-css-extract-plugin
export default {"container":"CaseComments_container__KiBxE"};